import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    output,
    signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NgIcon } from '@ng-icons/core';
import { QpxButton, QpxIcon, QpxTypography } from '@quipex/shared/ui';
import { QUIPPY_HOST_ACTIONS } from '../../../../integration';
import type { PackActionState } from '../../../../runtime/pack-actions/models';
import { QuippyPackPreview } from '../pack-preview/pack-preview';
@Component({
    selector: 'qpx-quippy-pack-result',
    imports: [
        QuippyPackPreview,
        QpxButton,
        MatButtonModule,
        NgIcon,
        QpxIcon,
        QpxTypography,
    ],
    templateUrl: './pack-result.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuippyPackResult {
    private readonly hostActions = inject(QUIPPY_HOST_ACTIONS, {
        optional: true,
    });
    public readonly state = input<PackActionState>();
    public readonly actionId = input.required<string>();
    public readonly applyClicked = output<void>();
    public readonly editClicked = output<void>();
    protected readonly error = signal('');
    protected readonly requirementsToReview = computed(() => {
        const current = this.state();
        if (current?.phase !== 'applied') return undefined;
        const skippedIds = new Set(current.pack.skippedRequirementIds ?? []);
        if (!skippedIds.size) return undefined;
        return current.pack.sections.flatMap((section) =>
            section.requirements
                .filter((requirement) => skippedIds.has(requirement.id))
                .map((requirement) => ({
                    id: requirement.id,
                    name: requirement.name,
                    sectionName: section.name,
                }))
        );
    });
    protected async openPack(
        buildingId: string,
        packId?: string
    ): Promise<void> {
        const opened = await this.hostActions?.openPack?.(buildingId, packId);
        if (!opened)
            this.error.set(
                'Could not open the pack. You can find it in the building Packs page.'
            );
    }
}
